export default __webpack_public_path__ + "static/media/illustrate-document-jpg.1d5df2f7.svg";